import React from 'react';
import Header from '../common/header/header';
import Footer from '../common/footer/footer';
import '../login/login.css';
import CommonMessage from './../common/commonMessage';
import { userService } from './../../services/user.service';
import ReCAPTCHA from "react-google-recaptcha";
import Validate from './../common/validate';

class Forgotpassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            usernameempty: false,
            message: "",
            isAction: false,
            isbuttondisabled: false,
            successMessage: false,
            errorMessage: false,
            errMsgDesc: "",
            emailRegex: false,
            emailShow: false,
        };
        this.handleInput = this.handleInput.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {
        // debugger;
        document.title = "IDrive® Compute | Forgot password";
        // const link = document.createElement("link")
        // link.href = "https://www.idrivecompute.com/webapp/css/login-page.css"
        // link.rel = "stylesheet"
        // link.type = "text/css"
        // document.head.appendChild(link)

        // const link1 = document.createElement("link")
        // link1.href = "https://www.idrivecompute.com/webapp/css/static-common.css"
        // link1.rel = "stylesheet"
        // link1.type = "text/css"
        // document.head.appendChild(link1)
        this.timerID = setInterval(
            () => this.setState({ errorMessage: false }),
            25000
        );
        const queryParams = new URLSearchParams(window.location.search);
        let name = queryParams.get("username");
        if(name !== null && name.indexOf(' ')) {
            name = window.location.search.split('=')[1];
        }
        if(name) {
            this.setState({
                emailShow: true,
                username: name,
                usernameempty: false,
                emailRegex: false
            });
        }
    }

    handleInput(event) {
        let val = event.target.value;

        this.setState({
            username: val,
            usernameempty: false,
            emailRegex: false
        });
    }
    submitForm(event) {

        event.preventDefault();
        if(this.state.username.length <= 0) {
            this.setState({
                usernameempty: true,
                emailRegex: false
            });
            return;
        }
        else if(!Validate("email", this.state.username)) {
            this.setState({
                usernameempty: false,
                emailRegex: true
            });
            return;
        }
        else {
            this.recaptchaRef.current.execute();
        }
    }

    onRecaptchaChange = (event) => {
        this.setState({ isAction: true });
        userService.recoverypassword(this.state.username, event).then((resp) => {

            if(resp === false) {
                this.setState({
                    errMsgDesc: "Error while recovering the password",
                    isAction: false,
                    errorMessage: true
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
                return;
            }
            if(resp.data.body.error) {
                this.setState({
                    errMsgDesc: "If your email/username exists in our system, you will receive an email with instructions to reset the password. ",
                    isAction: false,
                    errorMessage: true
                });
                setTimeout(() => {
                    this.setState({
                        errorMessage: false,
                        isbuttondisabled: false
                    });
                }, 5000);
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
                return;
            }
            this.setState({
                username: "",
                isAction: false,
                isbuttondisabled: true,
                successMessage: true,
                errorMessage: false
            });
            setTimeout(() => {
                this.setState({
                    isbuttondisabled: false,
                    successMessage: false
                });
            }, 5000);
        });
    };
    render() {


        return (
            <div>

                <Header />
                <div className="body_inner">
                    <main className="static">
                        <div id="static_form_wrap">
                            <div className="sign_in_bg"></div>
                            <div className="wrapper">
                                <div className="box_center_align">
                                    <form id="signin-form" onSubmit={ this.submitForm }>
                                        <div className="box_header_text">
                                            <h1>{ this.state.emailShow ? "Set Password" : "Forgot Password ?" }</h1>
                                        </div>
                                        <div className="box_inner_wrap">
                                            <div className="msg_box" style={ { display: this.state.successMessage ? "block" : "none" } }>
                                                <div className="common_msg success">
                                                    <div className="icon" style={ { width: "40px" } }></div>
                                                    <div className="info">If your email/username exists in our system, you will receive an email with instructions to reset the password. </div>
                                                </div>
                                            </div>
                                            <div className="msg_box" style={ { display: this.state.errorMessage ? "block" : "none" } }>
                                                <div className="common_msg success">
                                                    <div className="icon" style={ { width: "40px" } }></div>
                                                    <div className="info">If your email/username exists in our system, you will receive an email with instructions to reset the password. </div>
                                                </div>
                                            </div>
                                            <div className="forgot_pwd">
                                                <p className="frget_alert">A link to set a new password for your account will be sent to the email address.</p>
                                                <span className="frget_info">You may need to check your spam folder or add <strong>support@idrive.com</strong> and <strong>support@send.idrive.com</strong> to your contact list to make sure that emails get delivered to your inbox.</span>
                                                <div className="inp_row">
                                                    <label>Email</label>
                                                    <input type="text" autoFocus={ this.state.emailShow ? true : false } name="username" value={ this.state.username } className="txt-box" onChange={ this.handleInput } disabled={ this.state.emailShow }></input>
                                                    <span className="error_msg" style={ { display: this.state.usernameempty ? "block" : "none" } } >The field cannot be blank</span>
                                                    <span className="error_msg" style={ { display: this.state.emailRegex ? "block" : "none" } } >Email is invalid</span>
                                                </div>
                                                <div className="fp_reCaptcha">
                                                </div>
                                                <div className="footer_wrap">
                                                    <div className={ this.state.isAction ? "btn_wrap loginSubmitLoader" : "btn_wrap" }>
                                                        <input type="submit" name="" value={ this.state.isAction ? "" : "Send Link" } className={ this.state.isbuttondisabled ? "btn-primary disabled" : "btn-primary" } data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" ></input>
                                                    </div>
                                                </div>
                                                <div className="pwd_forget" style={ { display: "none" } }><a href="recover-username">Forgot your username?</a></div>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </main>
                    <div className="clear"></div>
                    <Footer />
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) } />
            </div>
        );
    }
}

export default Forgotpassword;